import {Component, Input, OnInit} from '@angular/core';
import {ChangeRequestVO} from '../../../generate/TldChangeResultVO';


@Component({
  selector: 'summary-of-changes',
  templateUrl: './summary-of-changes.component.html',
  styleUrls: ['./summary-of-changes.component.scss']
})
export class SummaryOfChangesComponent implements OnInit {

  @Input()
  changeRequest: ChangeRequestVO;

  @Input()
  showTicketNumbers: boolean;

  @Input()
  newDelegation: boolean;

  allChanges = new Map<string, Array<string>>();
  changeKeys: Array<string> = [];

  constructor() { }


  ngOnInit() {
    this.allChanges = new Map(Object.entries(this.changeRequest['changesHtml']));
    this.allChanges.forEach((value: string[], key: string) => {
      this.changeKeys.push(key);
    });
  }

}
